import LegacyApiService from "./LegacyApiService";

class ShortcutsService {
  getAll() {
    return LegacyApiService.get("/shortcuts");
  }
}

export default new ShortcutsService();
